module.exports = __webpack_public_path__ + "img/resources-banner.2c94ec08.jpg";